import { Button } from "@mui/material";
import { Google as GoogleIcon } from "@mui/icons-material";
import { getGoogleAuthUrl } from "@/api/auth.api";
import { hr } from "@/constants/strings.hr";

export function GoogleLoginButton({
  variant = "text",
}: {
  variant?: "text" | "contained" | "outlined";
}) {
  const handleLogin = () => {
    window.location.href = getGoogleAuthUrl();
  };

  return (
    <Button
      variant={variant}
      size="small"
      startIcon={<GoogleIcon />}
      onClick={handleLogin}
      sx={{ fontWeight: 600 }}
    >
      {hr.nav.login}
    </Button>
  );
}
